/** @format */

export const videos = [
  {
    _id: "W6NZfCO5SIk",
    title: "JavaScript Tutorial for Beginners: Learn JavaScript in 1 Hour",
    creator: "Programming with Mosh",
    thumbnail: "https://i.ytimg.com/vi/W6NZfCO5SIk/hqdefault.jpg",
    views: "7165340",
    uploaded: "2018-04-24T02:37:33Z",
    category: "javascript",
  },
  {
    _id: "ZvbzSrg0afE",
    title:
      "How JavaScript Works 🔥& Execution Context | Namaste JavaScript Ep.1",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/ZvbzSrg0afE/hqdefault.jpg",
    views: "358605",
    uploaded: "2020-10-19T11:52:56Z",
    category: "javascript",
  },
  {
    _id: "iLWTnMzWtj4",
    title:
      "How JavaScript Code is executed? ❤️& Call Stack | Namaste JavaScript Ep. 2",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/iLWTnMzWtj4/hqdefault.jpg",
    views: "342223",
    uploaded: "2020-10-20T09:11:14Z",
    category: "javascript",
  },
  {
    _id: "gSDncyuGw0s",
    title:
      "How functions work in JS ❤️ & Variable Environment | Namaste JavaScript Ep. 4",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/gSDncyuGw0s/hqdefault.jpg",
    views: "193131",
    uploaded: "2020-10-22T08:34:13Z",
    category: "javascript",
  },
  {
    _id: "QCRpVw2KXf8",
    title:
      "SHORTEST JS Program 🔥window & this keyword | Namaste JavaScript Ep. 5",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/QCRpVw2KXf8/hqdefault.jpg",
    views: "144870",
    uploaded: "2020-10-23T08:03:46Z",
    category: "javascript",
  },
  {
    _id: "Fnlnw8uY6jo",
    title:
      "Hoisting in JavaScript 🔥(variables & functions) | Namaste JavaScript Ep. 3",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/Fnlnw8uY6jo/hqdefault.jpg",
    views: "354268",
    uploaded: "2020-10-21T08:12:18Z",
    category: "javascript",
  },
  {
    _id: "B7iF6G3EyIk",
    title: "undefined vs not defined in JS 🤔 | Namaste JavaScript Ep. 6",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/B7iF6G3EyIk/hqdefault.jpg",
    views: "205457",
    uploaded: "2020-10-24T06:59:10Z",
    category: "javascript",
  },
  {
    _id: "uH-tVP8MUs8",
    title:
      "The Scope Chain, 🔥Scope & Lexical Environment | Namaste JavaScript Ep. 7",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/uH-tVP8MUs8/hqdefault.jpg",
    views: "196442",
    uploaded: "2020-10-27T09:22:43Z",
    category: "javascript",
  },
  {
    _id: "BNC6slYCj50",
    title:
      "let & const in JS 🔥Temporal Dead Zone | | Namaste JavaScript Ep. 8",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/BNC6slYCj50/hqdefault.jpg",
    views: "201841",
    uploaded: "2020-11-05T07:07:04Z",
    category: "javascript",
  },
  {
    _id: "lW_erSjyMeM",
    title: "BLOCK SCOPE & Shadowing in JS 🔥| Namaste JavaScript 🙏 Ep. 9",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/lW_erSjyMeM/hqdefault.jpg",
    views: "152327",
    uploaded: "2020-11-08T07:44:04Z",
    category: "javascript",
  },
  {
    _id: "qikxEIxsXco",
    title: "Closures in JS 🔥 | Namaste JavaScript Episode 10",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/qikxEIxsXco/hqdefault.jpg",
    views: "260365",
    uploaded: "2020-12-01T05:45:14Z",
    category: "javascript",
  },
  {
    _id: "eBTBG4nda2A",
    title:
      "setTimeout + Closures Interview Question 🔥 | Namaste 🙏 JavaScript Ep. 11",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/eBTBG4nda2A/hqdefault.jpg",
    views: "238715",
    uploaded: "2020-12-07T14:30:02Z",
    category: "javascript",
  },
  {
    _id: "SHINoHxvTso",
    title:
      "FIRST CLASS FUNCTIONS 🔥ft. Anonymous Functions | Namaste JavaScript Ep. 13",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/SHINoHxvTso/hqdefault.jpg",
    views: "150932",
    uploaded: "2020-12-15T05:37:32Z",
    category: "javascript",
  },
  {
    _id: "8zKuNo4ay8E",
    title:
      "Asynchronous JavaScript & EVENT LOOP from scratch 🔥 | Namaste JavaScript Ep.15",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/8zKuNo4ay8E/hqdefault.jpg",
    views: "307898",
    uploaded: "2020-12-27T03:38:05Z",
    category: "javascript",
  },
  {
    _id: "HkWxvB1RJq0",
    title:
      "Higher-Order Functions ft. Functional Programming | Namaste JavaScript Ep. 18",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/HkWxvB1RJq0/hqdefault.jpg",
    views: "145857",
    uploaded: "2021-06-08T14:30:13Z",
    category: "javascript",
  },
  {
    _id: "zdp0zrpKzIE",
    title: "map, filter & reduce 🙏 Namaste JavaScript Ep. 19 🔥",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/zdp0zrpKzIE/hqdefault.jpg",
    views: "275723",
    uploaded: "2021-07-21T04:30:12Z",
    category: "javascript",
  },
  {
    _id: "qz0aGYrrlhU",
    title: "HTML Tutorial for Beginners: HTML Crash Course",
    creator: "Programming with Mosh",
    thumbnail: "https://i.ytimg.com/vi/qz0aGYrrlhU/hqdefault.jpg",
    views: "3411890",
    uploaded: "2021-01-11T14:30:10Z",
    category: "html",
  },
  {
    _id: "pQN-pnXPaVg",
    title: "HTML Full Course - Build a Website Tutorial",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/pQN-pnXPaVg/hqdefault.jpg",
    views: "5454525",
    uploaded: "2018-09-18T17:02:21Z",
    category: "html",
  },
  {
    _id: "Rek0NWPCNOc",
    title: "HTML Course | From Beginners to Advance Level | Lecture 1",
    creator: "Apna College",
    thumbnail: "https://i.ytimg.com/vi/Rek0NWPCNOc/hqdefault.jpg",
    views: "1797683",
    uploaded: "2020-12-13T13:30:12Z",
    category: "html",
  },
  {
    _id: "1Rs2ND1ryYc",
    title: "CSS Tutorial - Zero to Hero (Complete Course)",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/1Rs2ND1ryYc/hqdefault.jpg",
    views: "2306584",
    uploaded: "2019-10-16T15:16:56Z",
    category: "css",
  },
  {
    _id: "1PnVor36_40",
    title: "Learn CSS in 20 Minutes",
    creator: "Web Dev Simplified",
    thumbnail: "https://i.ytimg.com/vi/1PnVor36_40/hqdefault.jpg",
    views: "848442",
    uploaded: "2018-08-23T01:13:45Z",
    category: "css",
  },
  {
    _id: "bMknfKXIFA8",
    title:
      "React Course - Beginner's Tutorial for React JavaScript Library [2022]",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/bMknfKXIFA8/hqdefault.jpg",
    views: "736215",
    uploaded: "2022-01-10T14:47:57Z",
    category: "react",
  },
  {
    _id: "I4yDcWWuf14",
    title:
      "Jesse Kipp - Reconciliation: The Root of Performant Applications | React Next 2019",
    creator: "ReactNext",
    thumbnail: "https://i.ytimg.com/vi/I4yDcWWuf14/hqdefault.jpg",
    views: "6776",
    uploaded: "2019-07-04T14:25:20Z",
    category: "react",
  },
  {
    _id: "dpw9EHDh2bM",
    title: "React Today and Tomorrow and  90% Cleaner React With Hooks",
    creator: "React Conf",
    thumbnail: "https://i.ytimg.com/vi/dpw9EHDh2bM/hqdefault.jpg",
    views: "980517",
    uploaded: "2018-10-26T15:59:13Z",
    category: "react",
  },
  {
    _id: "jLS0TkAHvRg",
    title: "React 18 Fundamentals Crash Course 2022",
    creator: "Codevolution",
    thumbnail: "https://i.ytimg.com/vi/jLS0TkAHvRg/hqdefault.jpg",
    views: "24184",
    uploaded: "2022-04-10T13:30:17Z",
    category: "react",
  },
  {
    _id: "W6NZfCO5SIk",
    title: "JavaScript Tutorial for Beginners: Learn JavaScript in 1 Hour",
    creator: "Programming with Mosh",
    thumbnail: "https://i.ytimg.com/vi/W6NZfCO5SIk/hqdefault.jpg",
    views: "7165340",
    uploaded: "2018-04-24T02:37:33Z",
    category: "javascript",
  },
  {
    _id: "ZvbzSrg0afE",
    title:
      "How JavaScript Works 🔥& Execution Context | Namaste JavaScript Ep.1",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/ZvbzSrg0afE/hqdefault.jpg",
    views: "358605",
    uploaded: "2020-10-19T11:52:56Z",
    category: "javascript",
  },
  {
    _id: "iLWTnMzWtj4",
    title:
      "How JavaScript Code is executed? ❤️& Call Stack | Namaste JavaScript Ep. 2",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/iLWTnMzWtj4/hqdefault.jpg",
    views: "342223",
    uploaded: "2020-10-20T09:11:14Z",
    category: "javascript",
  },
  {
    _id: "gSDncyuGw0s",
    title:
      "How functions work in JS ❤️ & Variable Environment | Namaste JavaScript Ep. 4",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/gSDncyuGw0s/hqdefault.jpg",
    views: "193131",
    uploaded: "2020-10-22T08:34:13Z",
    category: "javascript",
  },
  {
    _id: "QCRpVw2KXf8",
    title:
      "SHORTEST JS Program 🔥window & this keyword | Namaste JavaScript Ep. 5",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/QCRpVw2KXf8/hqdefault.jpg",
    views: "144870",
    uploaded: "2020-10-23T08:03:46Z",
    category: "javascript",
  },
  {
    _id: "Fnlnw8uY6jo",
    title:
      "Hoisting in JavaScript 🔥(variables & functions) | Namaste JavaScript Ep. 3",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/Fnlnw8uY6jo/hqdefault.jpg",
    views: "354268",
    uploaded: "2020-10-21T08:12:18Z",
    category: "javascript",
  },
  {
    _id: "B7iF6G3EyIk",
    title: "undefined vs not defined in JS 🤔 | Namaste JavaScript Ep. 6",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/B7iF6G3EyIk/hqdefault.jpg",
    views: "205457",
    uploaded: "2020-10-24T06:59:10Z",
    category: "javascript",
  },
  {
    _id: "uH-tVP8MUs8",
    title:
      "The Scope Chain, 🔥Scope & Lexical Environment | Namaste JavaScript Ep. 7",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/uH-tVP8MUs8/hqdefault.jpg",
    views: "196442",
    uploaded: "2020-10-27T09:22:43Z",
    category: "javascript",
  },
  {
    _id: "BNC6slYCj50",
    title:
      "let & const in JS 🔥Temporal Dead Zone | | Namaste JavaScript Ep. 8",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/BNC6slYCj50/hqdefault.jpg",
    views: "201841",
    uploaded: "2020-11-05T07:07:04Z",
    category: "javascript",
  },
  {
    _id: "lW_erSjyMeM",
    title: "BLOCK SCOPE & Shadowing in JS 🔥| Namaste JavaScript 🙏 Ep. 9",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/lW_erSjyMeM/hqdefault.jpg",
    views: "152327",
    uploaded: "2020-11-08T07:44:04Z",
    category: "javascript",
  },
  {
    _id: "qikxEIxsXco",
    title: "Closures in JS 🔥 | Namaste JavaScript Episode 10",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/qikxEIxsXco/hqdefault.jpg",
    views: "260365",
    uploaded: "2020-12-01T05:45:14Z",
    category: "javascript",
  },
  {
    _id: "eBTBG4nda2A",
    title:
      "setTimeout + Closures Interview Question 🔥 | Namaste 🙏 JavaScript Ep. 11",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/eBTBG4nda2A/hqdefault.jpg",
    views: "238715",
    uploaded: "2020-12-07T14:30:02Z",
    category: "javascript",
  },
  {
    _id: "SHINoHxvTso",
    title:
      "FIRST CLASS FUNCTIONS 🔥ft. Anonymous Functions | Namaste JavaScript Ep. 13",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/SHINoHxvTso/hqdefault.jpg",
    views: "150932",
    uploaded: "2020-12-15T05:37:32Z",
    category: "javascript",
  },
  {
    _id: "8zKuNo4ay8E",
    title:
      "Asynchronous JavaScript & EVENT LOOP from scratch 🔥 | Namaste JavaScript Ep.15",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/8zKuNo4ay8E/hqdefault.jpg",
    views: "307898",
    uploaded: "2020-12-27T03:38:05Z",
    category: "javascript",
  },
  {
    _id: "HkWxvB1RJq0",
    title:
      "Higher-Order Functions ft. Functional Programming | Namaste JavaScript Ep. 18",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/HkWxvB1RJq0/hqdefault.jpg",
    views: "145857",
    uploaded: "2021-06-08T14:30:13Z",
    category: "javascript",
  },
  {
    _id: "zdp0zrpKzIE",
    title: "map, filter & reduce 🙏 Namaste JavaScript Ep. 19 🔥",
    creator: "Akshay Saini",
    thumbnail: "https://i.ytimg.com/vi/zdp0zrpKzIE/hqdefault.jpg",
    views: "275723",
    uploaded: "2021-07-21T04:30:12Z",
    category: "javascript",
  },
  {
    _id: "qz0aGYrrlhU",
    title: "HTML Tutorial for Beginners: HTML Crash Course",
    creator: "Programming with Mosh",
    thumbnail: "https://i.ytimg.com/vi/qz0aGYrrlhU/hqdefault.jpg",
    views: "3411890",
    uploaded: "2021-01-11T14:30:10Z",
    category: "html",
  },
  {
    _id: "pQN-pnXPaVg",
    title: "HTML Full Course - Build a Website Tutorial",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/pQN-pnXPaVg/hqdefault.jpg",
    views: "5454525",
    uploaded: "2018-09-18T17:02:21Z",
    category: "html",
  },
  {
    _id: "Rek0NWPCNOc",
    title: "HTML Course | From Beginners to Advance Level | Lecture 1",
    creator: "Apna College",
    thumbnail: "https://i.ytimg.com/vi/Rek0NWPCNOc/hqdefault.jpg",
    views: "1797683",
    uploaded: "2020-12-13T13:30:12Z",
    category: "html",
  },
  {
    _id: "1Rs2ND1ryYc",
    title: "CSS Tutorial - Zero to Hero (Complete Course)",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/1Rs2ND1ryYc/hqdefault.jpg",
    views: "2306584",
    uploaded: "2019-10-16T15:16:56Z",
    category: "css",
  },
  {
    _id: "1PnVor36_40",
    title: "Learn CSS in 20 Minutes",
    creator: "Web Dev Simplified",
    thumbnail: "https://i.ytimg.com/vi/1PnVor36_40/hqdefault.jpg",
    views: "848442",
    uploaded: "2018-08-23T01:13:45Z",
    category: "css",
  },
  {
    _id: "bMknfKXIFA8",
    title:
      "React Course - Beginner's Tutorial for React JavaScript Library [2022]",
    creator: "freeCodeCamp.org",
    thumbnail: "https://i.ytimg.com/vi/bMknfKXIFA8/hqdefault.jpg",
    views: "736215",
    uploaded: "2022-01-10T14:47:57Z",
    category: "react",
  },
  {
    _id: "I4yDcWWuf14",
    title:
      "Jesse Kipp - Reconciliation: The Root of Performant Applications | React Next 2019",
    creator: "ReactNext",
    thumbnail: "https://i.ytimg.com/vi/I4yDcWWuf14/hqdefault.jpg",
    views: "6776",
    uploaded: "2019-07-04T14:25:20Z",
    category: "react",
  },
  {
    _id: "dpw9EHDh2bM",
    title: "React Today and Tomorrow and  90% Cleaner React With Hooks",
    creator: "React Conf",
    thumbnail: "https://i.ytimg.com/vi/dpw9EHDh2bM/hqdefault.jpg",
    views: "980517",
    uploaded: "2018-10-26T15:59:13Z",
    category: "react",
  },
  {
    _id: "jLS0TkAHvRg",
    title: "React 18 Fundamentals Crash Course 2022",
    creator: "Codevolution",
    thumbnail: "https://i.ytimg.com/vi/jLS0TkAHvRg/hqdefault.jpg",
    views: "24184",
    uploaded: "2022-04-10T13:30:17Z",
    category: "react",
  },
];
